import React from "react";
import { Colors } from "../../utils/colors";
import { formatDateToCardDate, formatDate } from "../../utils/utils";
import { TCText } from "../TCText/TCText";

type props = {
  expiryDate: string;
};

export const DefaultCardExpiry: React.FC<props> = ({ expiryDate }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        alignItems: "center",
        marginTop: 10,
      }}>
      <TCText
        style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
        value="Expires:"
      />
      <TCText
        style={{ color: Colors.green, fontWeight: 600, fontSize: 15 }}
        value={formatDateToCardDate(formatDate(expiryDate))}
      />
    </div>
  );
};
